export var DailyOptions;
(function (DailyOptions) {
    DailyOptions["EVERY"] = "every";
    DailyOptions["EVERY_WORKDAY"] = "everyWorkday";
})(DailyOptions || (DailyOptions = {}));
export var MonthlyOptions;
(function (MonthlyOptions) {
    MonthlyOptions["EVERY"] = "every";
    MonthlyOptions["THE"] = "the";
})(MonthlyOptions || (MonthlyOptions = {}));
export var YearlylyOptions;
(function (YearlylyOptions) {
    YearlylyOptions["ON"] = "on";
    YearlylyOptions["ON_SECOND_ROW"] = "on_second_row";
})(YearlylyOptions || (YearlylyOptions = {}));
export var MonthSpecifityOptions;
(function (MonthSpecifityOptions) {
    MonthSpecifityOptions["FIRST"] = "#1";
    MonthSpecifityOptions["SECOND"] = "#2";
    MonthSpecifityOptions["THIRD"] = "#3";
    MonthSpecifityOptions["FOURTH"] = "#4";
    MonthSpecifityOptions["LAST"] = "L";
})(MonthSpecifityOptions || (MonthSpecifityOptions = {}));
export var DaysOfTheWeek;
(function (DaysOfTheWeek) {
    DaysOfTheWeek["DAY"] = "day";
    DaysOfTheWeek["MONDAY"] = "2";
    DaysOfTheWeek["TUESDAY"] = "3";
    DaysOfTheWeek["WEDNESDAY"] = "4";
    DaysOfTheWeek["THURSDAY"] = "5";
    DaysOfTheWeek["FRIDAY"] = "6";
    DaysOfTheWeek["SATURDAY"] = "7";
    DaysOfTheWeek["SUNDAY"] = "1";
})(DaysOfTheWeek || (DaysOfTheWeek = {}));
export var Months;
(function (Months) {
    Months["JANUARY"] = "1";
    Months["FEBRUARY"] = "2";
    Months["MARCH"] = "3";
    Months["APRIL"] = "4";
    Months["MAY"] = "5";
    Months["JUNE"] = "6";
    Months["JULY"] = "7";
    Months["AUGUST"] = "8";
    Months["SEPTEMBER"] = "9";
    Months["OCTOBER"] = "10";
    Months["NOVEMBER"] = "11";
    Months["DECEMBER"] = "12";
})(Months || (Months = {}));
//# sourceMappingURL=oh-create-auto-report-interval-area.types.js.map
